import React from 'react';
import styled from 'styled-components';
import { InfoIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';

const EENCamerasBanner = () => {
  return (
    <EENBannerWrapper>
      <InfoIcon width={16} height={16} />
      <Text size="normal">Security cameras nearby</Text>
    </EENBannerWrapper>
  );
};

export default EENCamerasBanner;

const EENBannerWrapper = styled(Box).attrs({
  align: 'center',
  px: 20,
  py: 12,
  bg: 'primaryBase',
  color: 'background',
  horizontal: true,
  flow: 12,
  borderRadius: 5,
  width: '100%',
})``;
